import {
  ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output, ViewEncapsulation
} from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { BrandThemesEnum, IconSizeEnum, PositionEnum, SdHtmlComponent, SdIconComponent, SdTagComponent } from '@seb/web-design-system/core';

import type { IReview } from './review.interface';
import { SdRatingComponent } from '../rating/rating.component';

@Component({
  selector: 'sd-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdIconComponent,
    SdRatingComponent,
    SdTagComponent,
    TranslateModule,
    SdHtmlComponent
  ]
})
export class SdReviewComponent {
  iconSize = IconSizeEnum;
  brandThemesEnum = BrandThemesEnum;
  positionEnum = PositionEnum;

  @Input()
  icon: string;

  @Input()
  reviewContent: IReview;

  @HostBinding('class.is-small')
  @Input()
  isSmall = false;

  @Output()
  vote = new EventEmitter<boolean>();

  @Output()
  voteCancelled = new EventEmitter<boolean>();

  voteClick(vote: boolean) {
    this.vote.emit(vote);

    if (vote) {
      this.reviewContent.vote.positive.voted = true;
      this.reviewContent.vote.negative.voted = false;
    } else {
      this.reviewContent.vote.negative.voted = true;
      this.reviewContent.vote.positive.voted = false;
    }
  }

  cancelVote(vote: boolean) {
    this.voteCancelled.emit(vote);
    this.reviewContent.vote.positive.voted = false;
    this.reviewContent.vote.negative.voted = false;
  }
}
